import { Component } from '@angular/core';
import { SYSVERSION } from '../../config/app.config';

@Component({
    moduleId: module.id,
    selector: 'footer-cmp',
    templateUrl: 'footer.component.html'
})

export class FooterComponent{
    test : Date = new Date();
    public version: String = SYSVERSION;
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/layouts/footer/footer.component.ts